import React from 'react';
import Card from 'src/components/common/Card.redesign';
import CardContainer from 'src/components/common/CardContainer.redesign';
import Transmittal from 'src/models/dlcLease/Transmittal';
import TransmittalCard from './TransmittalCard';

interface ITransmittalsListComponentProps {
    transmittals: Transmittal[];
    onUpdateTransmittal: (transmittal: Transmittal) => void;
}

const TransmittalsList = (props: ITransmittalsListComponentProps) => {
    const processingCards = (obj: Transmittal) => {
        return (
            <div key={obj.transmit_no}>
                <TransmittalCard
                    transmittal={obj}
                    onUpdateTransmittal={props.onUpdateTransmittal}
                />
            </div>
        );
    };

    const newCard = () => {
        return (
            <CardContainer>
                {(props.transmittals?.length > 0) && props.transmittals?.map(processingCards)}
                {(props.transmittals === undefined || props.transmittals?.length === 0) && (
                    <Card>
                        <div className="agreements-card">
                            <div style={{ textAlign: 'center' }}>
                                <p>No Transmittals!</p>
                            </div>
                        </div>
                    </Card>
                )}
            </CardContainer>
        );
    };

    const headerList = () => {
        return (
            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0 1rem' }}>
                <div className="form-field" style={{ width: '10%' }}>Transmit No</div>
                <div className="form-field" style={{ width: '10%' }}>Doc Type</div>
                <div className="form-field" style={{ width: '20%' }}>Doc. Date</div>
                <div className="form-field" style={{ width: '40%' }}>Notary</div>
                <div className="form-field" style={{ width: '20%' }}>Phone</div>
            </div>
        );
    };

    return (
        <>
            {headerList()}
            {newCard()}
        </>
    );
};

export default TransmittalsList;


// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/ProcessingAndMaintenance/TransmittalsList.tsx